import React from 'react'
import HeroSection from '../components/hero-section'
import Layout from '../components/layout'

const Home = () => {
  return (
    <Layout>
        <HeroSection />
    </Layout>
  )
}

export default Home